var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 5.33301L6.80743 6.73672C7.55817 7.11209 8.44183 7.11209 9.19257 6.73672L12 5.33301M4 12.6663H12C13.1046 12.6663 14 11.7709 14 10.6663V5.33301C14 4.22844 13.1046 3.33301 12 3.33301H4C2.89543 3.33301 2 4.22844 2 5.33301V10.6663C2 11.7709 2.89543 12.6663 4 12.6663Z",
    stroke: "#808897",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail-icon.cd35aa583308962cf3cba796709fbab3.svg";
export { ForwardRef as ReactComponent };